module.exports = "/src/views/player/help/images/daln.jpg";